import { render, staticRenderFns } from "./WriteOffOrderInfo.vue?vue&type=template&id=185a9b1a&scoped=true&"
import script from "./WriteOffOrderInfo.vue?vue&type=script&lang=js&"
export * from "./WriteOffOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffOrderInfo.vue?vue&type=style&index=0&id=185a9b1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a9b1a",
  null
  
)

export default component.exports